import { Component, OnInit } from '@angular/core';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ClienteinfoService } from 'src/app/services/clienteinfo.service';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-confirmarllamada',
  templateUrl: './confirmarllamada.component.html',
  styleUrls: ['./confirmarllamada.component.scss']
})
export class ConfirmarllamadaComponent implements OnInit {

  disabled = true;

  constructor(
    private localsave: LocalSaveService,
    private gateway: GatewayService,
    private clienteinfo: ClienteinfoService,
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
  ) {

    // alert('tipologiacreada:' + this.localsave.get('tipologiacreada') + ' \nvalidatetipologiacreada:' + this.localsave.validate('tipologiacreada') + ' \nentrevistacreada:' + ' \nfasecli:' + this.localsave.get('fasecli').FASE);

    let resolvio = this.localsave.get('resuelto_nextclient').resolvio;

    // alert(resolvio)
    if (this.localsave.validate('tipologiacreada')
      && (this.localsave.get('fasecli').FASE == 2 ? this.localsave.validate('entrevistacreada') : true)) {
      this.disabled = false;
    }
    else if (resolvio) {
      this.disabled = false;
    }

    this.spinner.show();
    this.gateway.get('historicotipologias', { IDCLIENTE: this.clienteinfo.getcliente().cliente.idcliente, IDCAMPANA: this.clienteinfo.getcliente().idcampana })
      .then((result: any) => {
        this.spinner.hide();
        // console.log(result);
        let dataSource = result.rows;
        if (dataSource.length) {
          let resuelto = dataSource[0].resuelto;
          if (resuelto) {
            this.disabled = false;
          }
        } else {
          this.snackbar.open('Debe de tipificar la llamada antes de finalizarla por favor.', 'Cerrar', { duration: 7000 });
        }
        this.spinner.hide();
      }).catch((error: any) => {
        this.spinner.hide();
        this.snackbar.open('Ocurrio un error al verificar las tipificaciones realizadas. Notifiquelo al proveedor por favor', 'Cerrar', { duration: 7000 });
        this.spinner.hide();
      });
  }

  ngOnInit() {

  }

}
